// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"RoomPage_Wrapper__3t7S9","Container":"RoomPage_Container__1TRcM","Content":"RoomPage_Content__3F18y","Back":"RoomPage_Back__38lpI"};